import Api from "../config/Axios";

export const getRiderList = (token, user_id, headers) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/rider/list", config);
};

function objToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return keyValuePairs.join("&");
}

export const getRidersFiltersPagination = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };

  return Api.get("api/web/rider/list?keyword=" +
  (data.keyword ? data.keyword : "") +
  "&fleet_id=" +
  (data.fleet_id ? data.fleet_id : "") +
  "&status=" +
  (data.status ? data.status : "") +
  "&id=" +
  (data.id ? data.id : "") +
  "&zones=" +
  (data.zone ? data.zone : "") +
  "&page=" +
  (data.page ? data.page : 1) +
  "&limit=" +
  (data.limit ? data.limit : 100)  
  , config);
};

export const riderAdd = (data, headers) => {
  return Api.post("api/web/rider", data, { headers });
};

export const riderEdit = (riderId, data, headers) => {
  return Api.patch(`api/web/rider/update/${riderId}`, data, { headers });
};

export const riderApprove = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/approve", riderId, config);
};

export const riderBatchAssign = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-batch", riderId, config);
};

export const riderZoneAssign = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-zone", riderId, config);
};

export const riderBlock = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/block", riderId, config);
};

export const refreshTookanData = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  // return Api.get("api/web/rider/import", config);
  return Api.get("api/web/rider/fleet-import", config);
};

export const getRiderDetail = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/detail/${riderId}`, config);
};

export const getRiderMongoIDs = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log('bulk rider batch api',data)
  return Api.post("api/web/rider/display-ids", data, config);
};

export const getSingleRiderShifts = (riderId, pageNumber, pageSize) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log("config ", config);
  // return Api.get(`api/app/shift/rider/${riderId}`);
  return Api.get(`api/web/rider/shifts/${riderId}?page=${pageNumber}&limit=${pageSize}`, config);
};

export const getRiderTasks = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log("config ", config);
  // return Api.get(`api/app/shift/rider/${riderId}`);
  return Api.get(`api/web/tasks/rider/${data.id}?page=${data.page}&limit=${data.limit}`, config);
};

export const getRiderStatusLog = (data) => {
  const config = {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`, UserId: parseInt(localStorage.getItem("user_id"))}};
  return Api.get(`api/web/rider-status-backoffice-logs/detail/${data?.id}?page=${data?.page}&limit=${data?.limit}`, config);
  // {{preprod}}/api/web/rider-status-backoffice-logs/list
  // return
};

export const getRiderBatchLog = (data) => {
  const config = {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`, UserId: parseInt(localStorage.getItem("user_id"))}};
  return Api.get(`api/web/rider/batch/logs/${data?.id}?page=${data?.page}&limit=${data?.limit}`, config);
};

export const getRiderProfileImageLog = (data) => {
  const config = {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`, UserId: parseInt(localStorage.getItem("user_id"))}};
  return Api.get(`api/web/rider-profile-image-logs/list/${data?.id}?page=${data?.page}&limit=${data?.limit}`, config);
};

// Rider Brake
export const postRiderBrake = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/break", data, config);
};

// Rider list by zone
export const getRiderbyZone = (riderId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider-list/${riderId}`, config);
};

export const getAvalibleRiderbyZone = (zoneId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider-list-avalible/${zoneId}`, config);
};

export const RiderOngoingShift = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/rider/${riderId}/shift/ongoing`, config);
};

// Rider Assign Multi Zones
export const patchRiderZone = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-zone", data, config);
};

// Find rider by zone
export const getRidersByZone = (zoneId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider-list/${zoneId}`, config);
};

export const getRiderForceFree = (rId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/mark-force-free/${rId}`, config);
};

export const getReUpoadProfileImage = (rId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/re-upload-profile-image/${rId}`, config);
};


export const patchRiderSuspendStatus = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  // console.log("Rider Services", "api/web/rider/suspend-status", data, config)
  return Api.patch("api/web/rider/suspend-status", data, config);
};

export const patchRiderSyncRms = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/sync/rms", data, config);
};
